// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__QpIWF","choiceBoxes":"toolbarselects_choiceBoxes__2DXeG","simpleField":"toolbarselects_simpleField__3i_c6"};